<script setup>
import { ref } from "vue";
</script>

<template>
  <div>
    <div class="footer grid-x">
      <div class="cell small-0 medium-1 large-1"></div>
      <div class="cell small-12 medium-10 large-10 white-section">
        &copy; Copyright {{ new Date().getFullYear() }} | Blything-Collins Family
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "@/assets/styles/components/footer";
</style>
